export default __webpack_public_path__ + "static/media/software_light_mobile.80b1ca07.svg";